/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';

import EnrolmentStatus from 'linced-app/enums/enrolment-status';
import GroupType from '@linc-technologies/linced-common/enums/group-type';
import PersonType from '@linc-technologies/linced-common/enums/person-type';
import { hash } from '@linc-technologies/linced-common/utils/promise';
import moment from 'moment';

export default class EldestYoungestClassRoute extends Route {
  // Services
  @service
  store;

  // State
  year = moment().format('YYYY');

  model() {
    let statuses = JSON.stringify([
      EnrolmentStatus.CURRENT,
      EnrolmentStatus.PENDING,
    ]);
    return hash({
      homerooms: this.store.query('group', {
        groupType: GroupType.HOMEROOM,
        year: this.year,
      }),
      learners: this.store.query('person', {
        type: PersonType.LEARNER,
        statuses,
      }),
    });
  }
}
